import { OverlaysState, Overlay } from './types';

// eslint-disable-next-line import/prefer-default-export
export const getOverlayById = (overlayState: OverlaysState, id: string): Overlay => ({ ...overlayState.byIds[id] });
